// extracted by mini-css-extract-plugin
export default {"component":"LightButtonComponent_component__RRhNa"};